
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gqIvf4NCR6xpbMkQhUM1htQHqGFtMcO90rjFT61CWkMAMeta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexhxgDp_OfDNQnftf35KEKvdU_wS6NxURJOHjkBSQ6_m4Meta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchO86lPlH6YDjU5O35gUUyGFgAyEmic9Db5TlpHSR0GAcMeta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexNQIZ64Wb1svsx0LFFb78FUq4_45_45K0xoLKZezaQYJEk1EMeta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93QiIijbRJ3ZxooyjS9kzXhXzJG5WcCK7pLz0LffM8gUEMeta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexyfmZmlA4G_bCrFrPbIWZ_45KE5JTRP144mdqcvwwf5_454QMeta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93ChY5rsnfFQfJsWZIGjmeU_ojM7UQJJmf18OVf6F0C8wMeta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexMW10Abl_45_4593t132qADAWN_45d6ba2JjaTrvUzExbN14z0Meta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Oirl5vdrBUq6y9QJ_45V7fmWxxWjiyt9ZJk0KVBsP_fDkMeta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexdtTIdFkA7aRhRnaY7WCx_t_457xzSS49knjOiMGIWz4EkMeta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexZR30ObcrADAfxU8QaSkNK1csIRFsB0PP3IzYiLLtQ7cMeta } from "/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexyfmZmlA4G_bCrFrPbIWZ_45KE5JTRP144mdqcvwwf5_454QMeta || {},
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexMW10Abl_45_4593t132qADAWN_45d6ba2JjaTrvUzExbN14z0Meta || {},
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexdtTIdFkA7aRhRnaY7WCx_t_457xzSS49knjOiMGIWz4EkMeta || {},
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexZR30ObcrADAfxU8QaSkNK1csIRFsB0PP3IzYiLLtQ7cMeta || {},
    component: () => import("/codebuild/output/src30906007/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]